import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from './ContentCreatorPanel.css';
import { NavigatorStore } from '../stores';
import { IAContentCreator } from '../../contentCreator/ContentCreator';
import { Helper } from '../../../Helper';
import { IInstance } from '../../../interfaces/IInstance';
import InstanceService from '../../../services/InstanceService';

export interface IProps {
  navigatorStore?: NavigatorStore;
  isShowing?: boolean;
}

export interface IState {
}

@inject('navigatorStore')
@observer
export default class ContentCreatorPanel extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      content: [],
      searchQuery: '',
      isLoading: false,
      hasAllPeople: false,
      loadingMore: false,
    };

    this.handleClosePanel = this.handleClosePanel.bind(this);
  }

  public componentDidMount(): void {
    if (this.props.navigatorStore.componentInstances.Messages.length === 0) {
      this.loadInstances();
    }
  }

  private async loadInstances(): Promise<void> {
    let messagesInstances: IInstance[] = await InstanceService.getInstances(this.props.navigatorStore.environment, this.props.navigatorStore.token, this.props.navigatorStore.tenant, "IntraActive-Messages", false);
    messagesInstances.forEach(instance => {
      if (instance.instanceName == null) {
        instance.instanceName = "Default";
      }
    });
    this.props.navigatorStore.componentInstances.Messages = messagesInstances;
  }

  public render() {
    let top = 0;
    if (Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") {
      top = 48;
    }
    return (
      <div className={styles.contentCreatorContainer}>
        {this.props.navigatorStore.navigator != undefined &&
          <IAContentCreator
            show={this.props.navigatorStore.selectedContentCreator ? true : false}
            showFilter={false}
            environment={this.props.navigatorStore.environment}
            instance={this.props.navigatorStore.selectedContentCreator ? this.props.navigatorStore.selectedContentCreator.instance : undefined}
            token={this.props.navigatorStore.token}
            tenant={this.props.navigatorStore.tenant.indexOf(".sharepoint.com") !== -1 ? this.props.navigatorStore.tenant.replace(".sharepoint.com", "") : this.props.navigatorStore.tenant}
            highlightColor={this.props.navigatorStore.highlightColor}
            isMobile={this.props.navigatorStore.isMobile}
            marginTop={top}
            fontSlots={this.props.navigatorStore.fontSlots}
            user={this.props.navigatorStore.user}
            onClose={this.handleClosePanel}
            onCloseFilter={this.handleClosePanel}
            componentInstances={this.props.navigatorStore.componentInstances}
          />
        }
      </div>
    );
  }

  private handleClosePanel() {
    this.props.navigatorStore.selectedContentCreator = undefined;
    this.props.navigatorStore.selectTopMenuItem(undefined);
    document.body.style.overflowY = "auto";
    document.body.style.height = "inherit";
  }
}